import React from 'react';
import { Alert, Card, Tabs, Typography } from 'antd';
import PlanBilling from './PlanBilling';
import PlanManagement from './PlanManagement';
import SpecialitySectionManagement from './SpecialitySectionManagement';
import TbcUserManagement from './TbcUserManagement';
import LegalDocumentManagement from './LegalDocumentManagement';
import ProductPackageManagement from './ProductPackageManagement';
import GlobalOrganizationConfiguration from './GlobalOrganizationConfiguration';

const { Title, Text } = Typography;

/**
 * Centro de configuración de TheBlueCoding.
 *
 * Los componentes de cada módulo siguen siendo independientes (y sus rutas
 * directas se conservan por compatibilidad), pero desde aquí se presentan en
 * un único flujo de pestañas para que el administrador no tenga que buscar
 * cada funcionalidad en módulos separados.
 */
const CompanyManagement: React.FC = () => (
    <div className="tbc-admin-page">
        <Card bordered={false} style={{ marginBottom: 16 }}>
            <Title level={3} style={{ margin: '0 0 4px' }}>Gestión de empresa</Title>
            <Text type="secondary">
                Configuración global de TheBlueCoding y administración de los recursos que se ofrecen a las organizaciones.
            </Text>
            <Alert
                style={{ marginTop: 16 }}
                type="info"
                showIcon
                message="Personas y usuarios del portal son conceptos diferentes"
                description="Personas administra el personal de cada organización y sus licencias. Usuarios del portal administra las cuentas que ingresan a esta plataforma de gestión."
            />
        </Card>

        <Card bordered={false}>
            <Tabs
                destroyOnHidden
                items={[
                    {
                        key: 'operacion-interna',
                        label: 'Personas, gastos y métricas',
                        children: <PlanBilling moduleView="company" />
                    },
                    {
                        key: 'sistemas-modulos-roles',
                        label: 'Sistemas, módulos y roles',
                        children: <GlobalOrganizationConfiguration section="access" />
                    },
                    {
                        key: 'espacios-fisicos',
                        label: 'Tipos de espacio físico',
                        children: <GlobalOrganizationConfiguration section="spaces" />
                    },
                    {
                        key: 'tipos-documento',
                        label: 'Tipos de documento',
                        children: <GlobalOrganizationConfiguration section="documents" />
                    },
                    {
                        key: 'planes',
                        label: 'Gestión de planes',
                        children: <PlanManagement />
                    },
                    {
                        key: 'especialidades',
                        label: 'Gestión de especialidades',
                        children: <SpecialitySectionManagement />
                    },
                    {
                        key: 'usuarios-portal',
                        label: 'Usuarios del portal',
                        children: <TbcUserManagement />
                    },
                    {
                        key: 'documentos-legales',
                        label: 'Documentos legales',
                        children: <LegalDocumentManagement />
                    },
                    {
                        key: 'catalogo',
                        label: 'Catálogo global de servicios y productos',
                        children: <ProductPackageManagement />
                    }
                ]}
            />
        </Card>
    </div>
);

export default CompanyManagement;
